import React, { useEffect, useCallback, useContext } from "react";
import PropTypes from "prop-types";

import Overlay from "components/overlay";
import Icon from "components/icon";
import FreezeBody from "helpers/context/freeze_body";

function Modal({ title, onClose, className, children }) {
  const freezeBodyContext = useContext(FreezeBody);
  useEffect(() => {
    freezeBodyContext.freezeBody();
    return () => freezeBodyContext.unFreezeBody();
  }, []);

  const handleCloseClick = useCallback(
    event => {
      if (event && typeof event.stopPropagation === "function")
        event.stopPropagation();
      if (typeof onClose === "function") onClose();
    },
    [onClose]
  );

  const handleKeyup = useCallback(
    event => {
      if (event.key === "Escape") {
        handleCloseClick(event);
      }
    },
    [handleCloseClick]
  );

  useEffect(
    () => {
      document.addEventListener("keyup", handleKeyup, false);
      return () => document.removeEventListener("keyup", handleKeyup, false);
    },
    [handleKeyup]
  );

  const header = title && (
    <header>
      <h2>{title}</h2>
    </header>
  );

  const closeButton = typeof onClose === "function" && (
    <a className="close" onClick={handleCloseClick}>
      <Icon type="x" className="close" />
    </a>
  );

  return (
    <Overlay onClick={handleCloseClick}>
      <div className={`modal ${className}`}>
        {closeButton}
        {header}
        {children}
      </div>
    </Overlay>
  );
}

Modal.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
  className: "",
};

export default Modal;
